import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { getStoredResponse } from "../services/review.service";
import type { StoredResponseRequest, StoredResponseResult } from "../types/review.types";

export interface UseReviewsOptions extends Omit<
  UseQueryOptions<StoredResponseResult>,
  "queryKey" | "queryFn"
> {
  enabled?: boolean;
}

export const useReviews = (request: StoredResponseRequest | null, options?: UseReviewsOptions) => {
  return useQuery<StoredResponseResult>({
    queryKey: ["reviews", request?.document_id, request?.query_term],
    queryFn: () => {
      if (!request) {
        throw new Error("Request is required");
      }
      return getStoredResponse(request);
    },
    enabled: !!request && options?.enabled !== false,
    ...options,
  });
};
